// 好运大转盘
export default {
  routes: [
    {
      path: '/turntable',
      name: 'turntable',
      meta: {
        title: '好运大转盘'
      },
      component: () => import(/* webpackChunkName: "turntable" */ '../views/turntable/index.vue')
    }
  ]
}
